import { MessageBarType } from '@fluentui/react'
import { wrap } from 'comlink'
import { format } from 'date-fns'
import { call, put, select, takeLatest } from 'typed-redux-saga'
import { createAsyncAction } from 'typesafe-actions'
import { pushNotification } from '../../../../../../../features/Notifications'
import { downloadUrlAsFile } from '../../../../../../../shared/downloads'
import { AppState } from '../../../../../../../store'
import {
  createAsyncReducer,
  createAsyncSelectors
} from '../../../../../../../store/shared/asyncStore'
import { getAllPagedOdataApiResults } from '../../../../../../../store/shared/sagas/odata'
import type { ManagedAccountFeeExportWorker } from '../export'
import {
  fetchManagedAccountFeeHistory,
  managedAccountFeeHistoryListUiSelectors
} from './managedAccountFeeHistoryList'

export const managedAccountFeeHistoryExportActions = createAsyncAction(
  '@modules/@advisory/@modules/@accounts/@modules/@managedAccountFeeHistory/EXPORT_REQUEST',
  '@modules/@advisory/@modules/@accounts/@modules/@managedAccountFeeHistory/EXPORT_SUCCESS',
  '@modules/@advisory/@modules/@accounts/@modules/@managedAccountFeeHistory/EXPORT_FAILURE'
)<undefined, undefined, Error>()

export const managedAccountFeeHistoryExportReducer = createAsyncReducer(
  managedAccountFeeHistoryExportActions
)

const rootSelector = (state: AppState) =>
  state.modules.advisory.modules.accounts.modules.managedAccountFeeHistory
    .managedAccountFeeHistoryExport

export const {
  getError: getManagedAccountFeeExportError,
  getIsLoading: getIsManagedAccountFeeHistoryExportLoading
} = createAsyncSelectors(rootSelector)

const onExport = function* () {
  try {
    const request = yield* select(
      managedAccountFeeHistoryListUiSelectors.getOdataRequest
    )
    const results = yield* call(() =>
      getAllPagedOdataApiResults(request, fetchManagedAccountFeeHistory)
    )

    const worker = new Worker(new URL('../export.ts', import.meta.url))
    const { createAndDownloadManagedAccountFeeHistoryExport } =
      wrap<ManagedAccountFeeExportWorker>(worker)

    const result = yield* call(
      createAndDownloadManagedAccountFeeHistoryExport,
      results
    )

    const filename = `Managed Account Fee History ${format(
      new Date(),
      'MM-dd-yyyy'
    )}.xlsx`
    downloadUrlAsFile(result, filename)
    yield put(managedAccountFeeHistoryExportActions.success())
  } catch (e: unknown) {
    yield put(managedAccountFeeHistoryExportActions.failure(e as Error))
  }
}

const onFailure = function* (
  action: ReturnType<typeof managedAccountFeeHistoryExportActions.failure>
) {
  yield call(pushNotification, {
    message: `Export failed: ${action.payload.message}`,
    type: MessageBarType.error
  })
}

export const managedAccountFeeHistoryExportSagas = [
  () => takeLatest(managedAccountFeeHistoryExportActions.request, onExport),
  () => takeLatest(managedAccountFeeHistoryExportActions.failure, onFailure)
]
